import { createFileRoute } from '@tanstack/react-router';
import { Dashboard } from './me';

export const Route = createFileRoute('/')({ component: Dashboard });
